var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgModalGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 24,
    fill: "#64FF32",
    stroke: "#64FF32",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0008 16.3202C25.9556 16.3202 26.7369 17.1015 26.7369 18.0563V25.0008C26.7369 25.9556 25.9556 26.7369 25.0008 26.7369C24.0459 26.7369 23.2646 25.9556 23.2646 25.0008V18.0563C23.2646 17.1015 24.0459 16.3202 25.0008 16.3202ZM24.9834 7.63965C15.4001 7.63965 7.63965 15.4174 7.63965 25.0008C7.63965 34.5841 15.4001 42.3619 24.9834 42.3619C34.5841 42.3619 42.3619 34.5841 42.3619 25.0008C42.3619 15.4174 34.5841 7.63965 24.9834 7.63965ZM25.0008 38.8896C17.3271 38.8896 11.1119 32.6744 11.1119 25.0008C11.1119 17.3271 17.3271 11.1119 25.0008 11.1119C32.6744 11.1119 38.8896 17.3271 38.8896 25.0008C38.8896 32.6744 32.6744 38.8896 25.0008 38.8896ZM26.7369 33.6813H23.2646V30.2091H26.7369V33.6813Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalGreen);
export default __webpack_public_path__ + "static/media/modalGreen.54b0b5053dab904159f7ff3a911e59e7.svg";
export { ForwardRef as ReactComponent };